import axios from "axios";
import Config from "../../config/";
import moment from "moment";
import { encryptPayload } from "../../utils/encryption";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;

export function encrypted(text) {
  return encryptPayload(text);
}

export function cekAuth() {
  return {
    headers: {
      Authorization: API_KEY + localStorage.getItem("token")
    }
  };
}

export function deleteAlert(id) {
  const url = `${ROOT_URL}alert/alert/${id}/`;

  const request = axios.delete(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function updateAlert(body) {
  const url = `${ROOT_URL}alert/alert/${body.id}/`;

  const fdata = new FormData();
  fdata.append("description", body.description);
  fdata.append("company_code", body.company_code);
  fdata.append("date", body.dateAlert);
  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function pushAlert(body) {
  const url = `${ROOT_URL}alert/alert/`;

  const fdata = new FormData();
  fdata.append("company_code", body.company_code);
  fdata.append("title", body.title);
  fdata.append("description", body.description);
  fdata.append("date", body.dateAlert);
  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function fetchLogActivity() {
  const url = `${ROOT_URL}logactivity/logactivity/?limit=1000`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchLogActivityPeriode(
  startdate,
  enddate,
  limit,
  offset,
  search
) {
  const url = `${ROOT_URL}logactivity/logactivityperiode/?startdate=${encrypted(
    startdate
  )}&enddate=${encrypted(enddate)}&limit=${encrypted(limit)}&offset=${encrypted(
    offset
  )}&search=${encrypted(search)}`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchLogLocation() {
  const url = `${ROOT_URL}logactivity/logactivitylocation/`;
  const request = axios.get(url, cekAuth());
  return request;
}

export function fetchLogUser() {
  const url = `${ROOT_URL}logactivity/logactivityuser/`;
  const request = axios.get(url, cekAuth());
  return request;
}
